export default {
  '临床研究总监': '临床研究总监',
  '项目经理': '项目经理',
  '高级临床监查员': '高级临床监查员 / 临床监查员 ',
  '项目专员': '项目专员',
  '注册经理': '注册经理 '
}